import { createRoot } from "react-dom/client";
export function bootstrapOfficeDialog(options) {
    const containerId = options.containerId || "container";
    const rootElement = globalThis.document?.getElementById(containerId);
    if (!rootElement) {
        options.onMissingContainer?.();
        return;
    }
    const root = createRoot(rootElement);
    const runRender = async (info = {}) => {
        await options.render(root, info);
    };
    const officeApi = globalThis.Office;
    if (officeApi?.onReady) {
        officeApi.onReady((info) => {
            void runRender(info || {});
        });
    }
    else {
        void runRender({});
    }
    if (options.enableHotReload !== false) {
        const maybeModule = globalThis.module;
        if (maybeModule?.hot) {
            maybeModule.hot.accept();
        }
    }
}
